import type { SVGProps } from "react";
const SenecPictogramNotBookable = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M14.5 15.4142L12.2071 17.7071L10.7929 16.2929L13.0858 14L10.7929 11.7071L12.2071 10.2929L14.5 12.5858L16.7929 10.2929L18.2071 11.7071L15.9142 14L18.2071 16.2929L16.7929 17.7071L14.5 15.4142Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 14C6.5 9.58172 10.0817 6 14.5 6C17.4611 6 20.0465 7.60879 21.4297 10H32.9142L38.5 15.5858V39C38.5 40.6569 37.1569 42 35.5 42H16.5C14.8431 42 13.5 40.6569 13.5 39V37C13.5 36.4477 13.9477 36 14.5 36C15.0523 36 15.5 36.4477 15.5 37V39C15.5 39.5523 15.9477 40 16.5 40H35.5C36.0523 40 36.5 39.5523 36.5 39V18H30.5V12H22.248C22.4125 12.6392 22.5 13.3094 22.5 14C22.5 18.0796 19.4463 21.446 15.5 21.9381V32C15.5 32.5523 15.0523 33 14.5 33C13.9477 33 13.5 32.5523 13.5 32V21.9381C9.55369 21.446 6.5 18.0796 6.5 14ZM32.5 12.4142V16H36.0858L32.5 12.4142ZM14.5 8C11.1863 8 8.5 10.6863 8.5 14C8.5 17.3137 11.1863 20 14.5 20C17.8137 20 20.5 17.3137 20.5 14C20.5 10.6863 17.8137 8 14.5 8Z"
            fill="currentColor"
        />
        <path d="M24.5 24V26H17.5V24H24.5Z" fill="currentColor" />
        <path d="M17.5 30V28H27.5V30H17.5Z" fill="currentColor" />
        <path d="M17.5 34H25.5V32H17.5V34Z" fill="currentColor" />
        <path d="M24.5 38H17.5V36H24.5V38Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramNotBookable;
